// chat.constants — стартові значення для сесії чату.

import i18n from "../i18n";

export function getInitialMessages() {
  return [
    {
      role: "assistant",
      animate: true,
      parts: [
        { t: i18n.t("chat:welcome_part1"), w: "bold" },
        { t: i18n.t("chat:welcome_part2"), w: "medium" },
        { t: i18n.t("chat:welcome_part3"), w: "bold" },
        { t: i18n.t("chat:welcome_part4"), w: "medium" },
      ],
    },
  ];
}

export function getInitialCTAs() {
  return [
    {
      id: "cta_sale",
      label: i18n.t("chat:cta_sale"),
      sublabel: i18n.t("chat:cta_sale_sub"),
      action: { type: "send", message: i18n.t("chat:msg_sale") },
    },
    {
      id: "cta_new",
      label: i18n.t("chat:cta_new"),
      sublabel: i18n.t("chat:cta_new_sub"),
      action: { type: "send", message: i18n.t("chat:msg_new") },
    },
    {
      id: "cta_top",
      label: i18n.t("chat:cta_top"),
      sublabel: i18n.t("chat:cta_top_sub"),
      action: { type: "send", message: i18n.t("chat:msg_top") },
    },
  ];
}